import i18nLocale from "@/helpers/locale";
import { colorReg } from "@/utils/regExp.js";

export const hexColorValidator = (_, value, callback) => {
  if (value === "" || value === null) {
    callback();
  } else {
    const _len = value.length;
    if ((_len === 4 || _len === 7) && colorReg.test(value)) {
      callback();
    }
    callback(new Error(i18nLocale("form.hexColorError")));
  }
};

export const hexColorToRgb = str => {
  if (!str) {
    return false;
  }
  let sColor = str.toLowerCase();

  if (sColor && colorReg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = "#";
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    let sColorChange = [];
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
    }
    return sColorChange;
    // return "rgb(" + sColorChange.join(",") + ")";
  }

  return [ sColor ];
};

export const getContrastYIQ = hexColor => {
  const colors = hexColorToRgb(hexColor);

  if (!colors || colors.length < 3) {
    return "light";
  }
  const [red, green, blue] = colors;
  let brightness;
  brightness = (red * 299) + (green * 587) + (blue * 114);
  brightness = brightness / 255000;

  if (brightness >= 0.5) {
    return "light";
  }
  return "dark";
};